import type { ReactNode } from 'react';
import { Link } from '../Link';

interface RelatedGuide {
  /** Root-relative route, e.g. /blog/youtube-transcript-api */
  to: string;
  title: string;
  /** One-line description shown under the title; may hold a `<Price>`. */
  blurb?: ReactNode;
}

export interface RelatedGuidesProps {
  items: RelatedGuide[];
}

/**
 * A row of related-post cards for the end of a blog post: the internal-linking
 * and next-steps module every top dev blog ships. Author passes `items`; cards
 * link via the router.
 */
export const RelatedGuides = ({ items }: RelatedGuidesProps) => (
  <div className="my-6 grid gap-3 sm:grid-cols-3">
    {items.map((g) => (
      <Link
        key={g.to}
        to={g.to}
        className="group rounded-10 border border-line bg-surface p-4 no-underline transition-colors hover:border-accent-line"
      >
        <div className="text-14 font-semibold leading-snug text-text group-hover:text-accent">
          {g.title}
        </div>
        {g.blurb ? <div className="mt-1.5 text-13 leading-snug text-text-2">{g.blurb}</div> : null}
      </Link>
    ))}
  </div>
);
